import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { Store } from '../redux/stores';

export const dismissWarn = async () => {
    try {
        await axios.put(`${process.env.REACT_APP_HOST}/user/dismiss`, {});
        return true;
    } catch (e) {
        return false;
    }
};

export const getHome = async () => {
    Store.dispatch(loadingActions.loadingStart('user.getHome'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/user/home');
        Store.dispatch(loadingActions.loadingEnd('user.getHome'));

        if (resp.data && resp.data.status === 'ok') {
            return resp.data.payload;
        } else {
            return resp.response.data;
        }
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('user.getHome'));
        return e.response.data;
    }
};